import { Avatar, Card, CardContent, Grid, IconButton, Modal, Tooltip, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CardHeader, CardLarge } from '../../../app/AppStyles';
import BackButton from '../../subcomponents/BackButton';
import ContentLoader from '../../subcomponents/ContentLoader';
import ListItemCard from '../../subcomponents/ListItemCard';
import PageLayout from '../../subcomponents/PageLayout';
import InformationEditCard from './InformationEditCard';
import { fetchInformationArticle, resetInformationArticleManagementStatus } from './informationManagementSlice';

import EditIcon from '@mui/icons-material/Edit';

export default function InformationManagementPage() {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { informationArticle } = useSelector((state) => state.management.information);

    const [openEdit, setOpenEdit] = useState(false);

    useEffect(() => {
        dispatch(fetchInformationArticle(id));
    }, [id]);

    const callbackEditModal = () => {
        setOpenEdit(false);
        dispatch(resetInformationArticleManagementStatus());
    };

    return (
        <PageLayout
            title={`${informationArticle.data?.title ?? "-"}`}
            content={
                <ContentLoader
                    successCondition={informationArticle.status === "success"}
                    errorCondition={informationArticle.status === "failed"}
                    content={
                        <>
                            <Grid container spacing={1} sx={{ mt: { xs: 0, md: 1 } }}>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <ListItemCard backgroundStyle={{ height: 1 }}
                                        primaryText={informationArticle.data?.title}
                                        secondaryText={resourceFinal[appLanguage].words.TITLE}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Card sx={{ ...CardLarge }}>
                                        <CardContent>
                                            <Typography variant="h6" sx={{ ...CardHeader }}>
                                                {informationArticle.data?.title}
                                            </Typography>
                                            <Typography
                                                variant="body1"
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(informationArticle.data?.content),
                                                }}
                                            ></Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Modal open={openEdit} onClose={callbackEditModal}>
                                <>
                                    <InformationEditCard handleClose={callbackEditModal} informationArticleId={id} />
                                </>
                            </Modal>
                        </>
                    }
                />
            } contentRight={
                <>
                    {informationArticle.status === "success" &&
                        <Tooltip title={resourceFinal[appLanguage].words.EDIT} placement="left" arrow>
                            <IconButton onClick={() => setOpenEdit(true)}>
                                <Avatar sx={{ bgcolor: 'secondary.main', p: 0.5 }}>
                                    <EditIcon sx={{ color: 'white.main', fontSize: 40 }} />
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                    }
                    <BackButton desktop enableBorder />
                </>
            }
            bottomBar
            disableContentBackground
        />
    );
}
